module.exports = __webpack_public_path__ + "img/ruban_5.aeb37966.png";